import { MarketingLayout } from "@/components/MarketingLayout";
import { Hero } from "@/components/landing/Hero";
import { LogoWall } from "@/components/landing/LogoWall";
import { FeatureGrid } from "@/components/landing/FeatureGrid";
import { ComparisonTable } from "@/components/landing/ComparisonTable";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Pricing } from "@/components/landing/Pricing";
import { FAQ } from "@/components/landing/FAQ";
import { EthicsStrip } from "@/components/landing/EthicsStrip";

export default function Home() {
  return (
    <MarketingLayout>
      <Hero />
      <LogoWall />
      <FeatureGrid />
      <ComparisonTable />
      <HowItWorks />
      <Pricing />
      <FAQ />
      <EthicsStrip />
    </MarketingLayout>
  );
}
